const MOS_OWNED_PROPERTY_KEYS = [
  'active',
  'additionnalAddress',
  'adress',
  'city',
  'country',
  'latitude',
  'longitude',
  'name',
  'postCode',
  'telephone',
  'timezone',
];

/**
 * Lock the card inputs holding store fields owned by Mapal OS, only editable on Mapal OS
 */
const lockMosOwnedInputs = (cardSettings) => ({
  ...cardSettings,
  inputs: cardSettings.inputs.map((input) =>
    MOS_OWNED_PROPERTY_KEYS.includes(input.propertyKey) ? { ...input, readOnly: true } : input,
  ),
});

export default lockMosOwnedInputs;
